import PropTypes from 'prop-types';
import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles'
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';
import classNames from 'classnames';

/* eslint-disable import/no-named-as-default */
import withRtl from '../../../components/hoc/Rtl';
import Default, { Mobile } from '../../../utils/mediaQueries';
import {customisedIntlFormatMessage} from '../../../utils/helpers';
import { setCustomFilters } from '../../../actions/filters';
import studentInfo from '../../../actions/studentInfo';
import {
  fetchSchedule,
  fetchAppointments,
  fetchStudentAppointments,
  fetchExpressedInterests,
  fetchNoMatchingTimeSlots,
  resetForm,
  fetchSharedSchedule,
  schedulingCompleted,
  removeNoMatchingTimeSlot,
  fetchSharedScheduleGTFiltered,
  fetchSharedScheduleGTFilteredLocations,
  fetchExpressedInterestsInstruments,
} from '../../../actions/scheduling';
import { getSchoolsPrograms } from '../../../actions/schools';
import { getStudentApplications } from '../../../actions/student';
import { showPopupContent } from '../../../actions/popup';
import {
  MAKE_APPOINTMENT_RESET,
  CANCEL_APPOINTMENT_RESET,
  UPDATE_APPOINTMENT_RESET,
  EXPRESS_INTEREST_RESET,
  UNEXPRESS_INTEREST_RESET,
  NO_MATCHING_TIMESLOT_RESET,
  REMOVE_NO_MATCHING_TIMESLOT_RESET,
} from '../../../constants';
import AppointmentList from '../AppointmentList';
import ExpressedInterestForm from '../ExpressedInterestForm';
import Loader from '../../../components/Loader';
import { CompositeProgramCard } from '../Program';
import ProgramList from '../ProgramList';
import ScheduleDetail from '../ScheduleDetail';
import ScheduleEmpty from '../ScheduleEmpty';
import ScheduleForm from '../ScheduleForm';
import ScheduleModal from '../ScheduleModal';
import ScheduleSubtitle from '../ScheduleSubtitle';
import ScheduleTitle from '../ScheduleTitle';
import messages from '../../../locale/messages';
import style from './Schedule.scss'; // eslint-disable-line css-modules/no-unused-class
import CoachmarksSchedule from '../../../coachmarksLocale/schedule/schedule';
import Coachmarks from '../../../components/Coachmarks';
import ButtonAction from '../../../components/ButtonAction';

const PROGRAMS = 'PROGRAMS';
const APPOINTMENTS = 'APPOINTMENTS';

const localMessages = defineMessages({
  appointmentsSHSDescription: {
    id: 'schedule.appointmentsSHSDescription',
    defaultMessage:
      'Scheduling is the last step in the online registration process for specialized high schools admissions. ' +
      'After this, taking the SHSAT or completing the audition is your application to these schools.',
    description: 'The SHS schedule appointments description',
  },
  appointmentsSHSProcessDescription: {
    id: 'schedule.appointmentsSHSProcessDescription',
    defaultMessage:
      'You can return here anytime before October 10 to request a new test or audition date. ' +
      'When you’re finished scheduling your test or audition for these programs, mark this application process as ‘scheduling complete’ to track your progress.',
    description: 'The SHS schedule process description',
  },
  noMatchingTimeSlotRemoved: {
    id: 'schedule.noMatchingTimeSlotRemoved',
    defaultMessage: 'Your registration has been canceled',
    description: 'Canceled registration (no matching time slot) popup string',
  },
});

class Schedule extends Component {
  constructor(props) {
    super(props);
    this.coachmarksHS = [
      {
        element: '[data-coachmark="schedule-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSchedule.stepOneParagraphOne),
      },
      {
        element: '[data-coachmark="schedule-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSchedule.stepOneParagraphTwo),
      },
      {
        element: '[data-coachmark="schedule-step-2"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSchedule.stepTwo),
      },
      {
        element: '[data-coachmark="schedule-step-3"]',
        intro: `${customisedIntlFormatMessage(props.intl,  CoachmarksSchedule.stepThreeParagraphOne)}${customisedIntlFormatMessage(props.intl,  
          CoachmarksSchedule.stepThreeParagraphTwo,
        )}`,
      },
      {
        element: '[data-coachmark="schedule-step-4"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSchedule.stepFour),
      },
    ];
    this.coachmarksHSMobile = [
      {
        element: '[data-coachmark="schedule-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSchedule.stepOneParagraphOne),
      },
      {
        element: '[data-coachmark="schedule-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSchedule.stepOneParagraphTwo),
      },
      {
        element: '[data-coachmark="schedule-step-2"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSchedule.stepTwo),
      },
      {
        element: '[data-coachmark="schedule-mobile-step-3"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSchedule.stepThreeParagraphOne),
      },
      {
        element: '[data-coachmark="schedule-mobile-step-3"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSchedule.stepThreeParagraphTwo),
      },
      {
        element: '[data-coachmark="schedule-mobile-step-3"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSchedule.stepFour),
      },
    ];

    this.coachmarksMS = [
      {
        element: '[data-coachmark="schedule-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSchedule.stepOneParagraphOneMiddleSchool),
      },
      {
        element: '[data-coachmark="schedule-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSchedule.stepOneParagraphTwoMiddleSchool),
      },
      {
        element: '[data-coachmark="schedule-step-2"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSchedule.stepTwoMiddleSchool),
      },
      {
        element: '[data-coachmark="schedule-step-3"]',
        intro: `${customisedIntlFormatMessage(props.intl,  
          CoachmarksSchedule.stepThreeParagraphOneMiddleSchool,
        )}${customisedIntlFormatMessage(props.intl,  CoachmarksSchedule.stepThreeParagraphTwoMiddleSchool)}`,
      },
    ];
    this.coachmarksMSMobile = [
      {
        element: '[data-coachmark="schedule-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSchedule.stepOneParagraphOneMiddleSchool),
      },
      {
        element: '[data-coachmark="schedule-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSchedule.stepOneParagraphTwoMiddleSchool),
      },
      {
        element: '[data-coachmark="schedule-step-2"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSchedule.stepTwoMiddleSchool),
      },
      {
        element: '[data-coachmark="schedule-mobile-step-3"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSchedule.stepThreeParagraphOneMiddleSchool),
      },
      {
        element: '[data-coachmark="schedule-mobile-step-3"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksSchedule.stepThreeParagraphTwoMiddleSchool),
      },
    ];

    switch (props.user.admissionProcess) {
      case 'MS':
        this.coachmarks = this.coachmarksMS;
        this.coachmarksMobile = this.coachmarksMSMobile;
        break;
      case 'HS':
        this.coachmarks = this.coachmarksHS;
        this.coachmarksMobile = this.coachmarksHSMobile;
        break;
      default:
        this.coachmarks = null;
        this.coachmarksMobile = null;
    }

    this.initialState = {
      showModal: false,
      showProgramDetailTop: false,
      program: null,
      directoryProgramId: null,
      directorySchoolId: null,
      detailShowsSchool: true,
      mobileRender: PROGRAMS,
      isSHS: false,
      isGT: false,
      isMS: false,
      composite: false,
    };

    this.state = { ...this.initialState };

    // Used for focusing schedule modal
    this.modalContainerRef = React.createRef();

    this.mobileRenderMapping = {
      PROGRAMS: this.renderPrograms,
      APPOINTMENTS: this.renderAppointments,
    };
  }

  componentDidMount() {
    this.props.studentInfo(this.props.user.applicationId);
    // fetch saved program data
    this.props.getSchoolsPrograms();
    this.props.fetchSchedule(this.props.user.applicationId);
    this.props.fetchSharedSchedule(this.props.user.applicationId);
    this.fetchAppointmentsData();
    this.props.fetchExpressedInterests(this.props.user.applicationId);
    this.props.fetchNoMatchingTimeSlots(this.props.user.applicationId);
    this.props.getStudentApplications(this.props.user.applicationId);
    this.props.fetchExpressedInterestsInstruments(this.props.user.applicationId);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.user !== this.props.user && nextProps.user.details.data.applications) {
      const application = nextProps.user.details.data.applications.find(
        app => `${app.id}` === nextProps.user.applicationId,
      );
      this.setState({
        isSHS: application && application.is_shs,
        isGT: application && application.is_gt,
        isMS: application && application.is_ms,
      });
    }
    if (nextProps.sharedSchedules.gtFilteredLoaded && !this.props.sharedSchedules.gtFilteredLoaded) {
      const { state } = this;
      this.setState({
        ...state,
        program: {
          ...state.program,
          schedule: {
            ...state.program.schedule,
            time_slots: nextProps.sharedSchedules.result[0].time_slots,
          },
        },
      });
    }

    // an appointment was created/updated
    if (
      (nextProps.appointmentForm.result.id &&
        this.props.appointmentForm.result.id !== nextProps.appointmentForm.result.id) ||
      (nextProps.updateAppointmentForm.result.id &&
        this.props.updateAppointmentForm.result.id !== nextProps.updateAppointmentForm.result.id)
    ) {
      this.fetchScheduleData();
      this.fetchAppointmentsData();
    }

    // an expression of interest was created
    if (
      nextProps.expressInterestForm.result.id &&
      this.props.expressInterestForm.result.id !== nextProps.expressInterestForm.result.id
    ) {
      this.props.getSchoolsPrograms();
      this.props.fetchSchedule(this.props.user.applicationId);
      this.props.fetchSharedSchedule(this.props.user.applicationId);
      this.props.fetchExpressedInterests(this.props.user.applicationId);
    }

    // a no matching time slot was created
    if (
      nextProps.noMatchingTimeSlotForm.result.id &&
      this.props.noMatchingTimeSlotForm.result.id !== nextProps.noMatchingTimeSlotForm.result.id
    ) {
      this.fetchScheduleData();
      this.props.fetchNoMatchingTimeSlots(this.props.user.applicationId);
    }

    // an appointment was canceled
    if (!this.props.cancelAppointmentForm.result && nextProps.cancelAppointmentForm.result) {
      this.fetchScheduleData();
      this.closeScheduleModal();
      this.resetProgramState();
    }

    // an expression of interest was removed
    if (!this.props.unexpressInterestForm.result && nextProps.unexpressInterestForm.result) {
      this.fetchScheduleData();
      this.closeExpressedInterestModal();
      this.resetProgramState();
    }

    // a no matching time slot was removed
    if (!this.props.removeNoMatchingTimeSlotForm.result && nextProps.removeNoMatchingTimeSlotForm.result) {
      this.fetchScheduleData();
      this.props.fetchNoMatchingTimeSlots(this.props.user.applicationId);
      this.resetNoMatchingTimeSlotForm();
    }

    // if the detail view is currently active and something changed with the programs, we need to update it
    if (this.props.programs !== nextProps.programs && this.state.directorySchoolId) {
      this.showSchoolDetail(this.state.directorySchoolId, this.state.directoryProgramId, true);
    }
  }

  componentDidUpdate(prevProps) {
    const prevRemoveNoMatchingTimeSlotForm = prevProps.removeNoMatchingTimeSlotForm;
    const currentRemoveNoMatchingTimeSlotForm = this.props.removeNoMatchingTimeSlotForm;

    if (!prevRemoveNoMatchingTimeSlotForm.result.id && currentRemoveNoMatchingTimeSlotForm.result.id) {
      this.props.showPopupContent({
        children: <FormattedMessage {...localMessages.noMatchingTimeSlotRemoved} />,
      });
    }
  }

  onAfterModalClose = () => {
    this.resetScheduleForm();
    this.resetExpressInterestForm();
    this.resetNoMatchingTimeSlotForm();
    this.resetProgramState();
  };

  getGTfiltered = kwargs => {
    this.props.fetchSharedScheduleGTFiltered(this.props.user.applicationId, kwargs);
  };

  getGTfilteredLocations = kwargs => {
    this.props.fetchSharedScheduleGTFilteredLocations(this.props.user.applicationId, kwargs);
  };

  fetchScheduleData = (applicationId = this.props.user.applicationId) => {
    this.props.getSchoolsPrograms();
    if (this.state.isSHS || this.state.isGT || this.state.isMS) {
      this.props.fetchSharedSchedule(applicationId);
      this.props.fetchSchedule(applicationId);
    } else {
      this.props.fetchSchedule(applicationId);
    }
  };

  fetchAppointmentsData = (applicationId = this.props.user.applicationId) => {
    this.props.fetchAppointments(applicationId);
    this.props.fetchStudentAppointments(applicationId);
  };

  closeModal = () => {
    this.setState({
      showModal: false,
    });
  };

  closeScheduleModal = () => {
    this.closeModal();
    this.resetScheduleForm();
  };

  closeExpressedInterestModal = () => {
    this.closeModal();
    this.resetExpressInterestForm();
  };

  mobileShowPrograms = () => {
    const isPrograms = this.state.mobileRender === PROGRAMS;
    this.setState({
      mobileRender: PROGRAMS,
      directorySchoolId: isPrograms ? this.state.directorySchoolId : null,
      directoryProgramId: isPrograms ? this.state.directoryProgramId : null,
    });
  };

  mobileShowAppointments = () => {
    const isAppointments = this.state.mobileRender === APPOINTMENTS;
    this.setState({
      mobileRender: APPOINTMENTS,
      directorySchoolId: isAppointments ? this.state.directorySchoolId : null,
      directoryProgramId: isAppointments ? this.state.directoryProgramId : null,
    });
  };

  resetScheduleForm = () => {
    this.props.resetForm(MAKE_APPOINTMENT_RESET);
    this.props.resetForm(CANCEL_APPOINTMENT_RESET);
    this.props.resetForm(UPDATE_APPOINTMENT_RESET);
  };

  resetProgramState = (resetDetail = false) => {
    this.setState({
      program: null,
      directorySchoolId: resetDetail ? null : this.state.directorySchoolId,
      directoryProgramId: resetDetail ? null : this.state.directoryProgramId,
    });
  };

  initScheduling = (program, composite = false) => {
    if (program.schedule) {
      this.props.resetForm(EXPRESS_INTEREST_RESET);
      this.props.resetForm(UNEXPRESS_INTEREST_RESET);

      this.setState({
        showModal: true,
        program,
        composite,
      });
    }
  };

  resetExpressInterestForm = () => {
    this.props.resetForm(EXPRESS_INTEREST_RESET);
    this.props.resetForm(UNEXPRESS_INTEREST_RESET);
  };

  resetNoMatchingTimeSlotForm = () => {
    this.props.resetForm(NO_MATCHING_TIMESLOT_RESET);
    this.props.resetForm(REMOVE_NO_MATCHING_TIMESLOT_RESET);
  };

  programClickAppointment = (directoryProgramId, directorySchoolId) => {
    this.setState({
      directorySchoolId,
      directoryProgramId,
      showProgramDetailTop: true,
      detailShowsSchool: false,
    });
  };

  programClick = (directoryProgramId, directorySchoolId) => {
    this.setState({
      directorySchoolId,
      directoryProgramId,
      detailShowsSchool: false,
    });
  };

  showSchoolDetail = (directorySchoolId, directoryProgramId, ignoreToggle = false) => {
    if (ignoreToggle || this.state.directorySchoolId !== directorySchoolId) {
      this.setState({
        directorySchoolId,
        directoryProgramId,
        detailShowsSchool: true,
      });
    } else {
      this.setState({
        directorySchoolId: null,
        directoryProgramId: null,
        detailShowsSchool: true,
      });
    }
  };

  showProgramList = () => {
    this.setState({
      directorySchoolId: null,
      directoryProgramId: null,
      showProgramDetailTop: false,
    });
  };

  isProgramDetail = () => this.state.directorySchoolId;

  schedulableProgramsExist = () => {
    const { programs, sharedSchedules } = this.props;
    return programs.result.filter(program => program.schedule).length > 0 || sharedSchedules.result.length > 0;
  };

  focusModal = () => {
    this.modalContainerRef.current.focus();
  };

  submitSchedulingStatus = (applicationId = this.props.user.applicationId) => {
    this.props.schedulingCompleted(applicationId, {
      id: applicationId,
      scheduling_completed: true,
    });
    window.location.reload();
  };

  removeNoMatchingTimeSlot = (noMatchingTimeSlotId, applicationId = this.props.user.applicationId) => {
    this.props.removeNoMatchingTimeSlot(applicationId, noMatchingTimeSlotId);
  };

  renderModal = () => {
    const { user, studentAppointments, intl, sharedSchedules } = this.props;
    const { showModal, program, composite, isGT } = this.state;

    let modalContent;
    let modalAriaLabel;
    let { closeModal } = this;

    if (program && program.schedule) {
      modalContent = (
        <ScheduleForm
          user={user}
          program={program}
          applicationId={user.applicationId}
          studentAppointments={studentAppointments.result}
          skipAssessments={composite}
          focusModal={this.focusModal}
          isGT={isGT}
          getGTfiltered={kwargs => this.getGTfiltered(kwargs)}
          getGTfilteredLocations={kwargs => this.getGTfilteredLocations(kwargs)}
          gtFilteredLoading={sharedSchedules.gtFilteredLoading}
          gtFilteredLoaded={sharedSchedules.gtFilteredLoaded}
          gtFilteredLocationsLoading={sharedSchedules.gtFilteredLocationsLoading}
          gtFilteredLocationsLoaded={sharedSchedules.gtFilteredLocationsLoaded}
          locations={this.props.sharedSchedules.locations}
        />
      );
      modalAriaLabel = customisedIntlFormatMessage(intl, messages.buttonScheduleAppointment);

      closeModal = this.closeScheduleModal;

      if (program.schedule.express_interest) {
        closeModal = this.closeExpressedInterestModal;
        modalContent = (
          <ExpressedInterestForm
            user={user}
            program={program}
            applicationId={user.applicationId}
            reset={this.closeExpressedInterestModal}
            isSHS={this.state.isSHS}
            isGT={this.state.isGT}
            isMS={this.state.isMS}
            isLG={this.state.isLG}
            expressedInterests={this.props.expressedInterests}
            expressedInterestsInstruments={this.props.expressedInterestsInstruments}
          />
        );
        modalAriaLabel = customisedIntlFormatMessage(intl, messages.buttonExpressInterest);
      }
    }

    return (
      <ScheduleModal
        show={showModal}
        close={closeModal}
        afterClose={this.onAfterModalClose}
        ariaLabel={modalAriaLabel}
        containerRef={this.modalContainerRef}
        focusModal={this.focusModal}
      >
        {modalContent}
      </ScheduleModal>
    );
  };

  renderPrograms = () => {
    const { isGT, isMS, isSHS, showProgramDetailTop } = this.state;
    const { sharedSchedules, user, mobile } = this.props;

    let programsTop;

    if (!(isSHS || isGT || isMS)) {
      programsTop = (
        <Default>
          <div className={style.scheduleTitle} data-coachmark="schedule-step-4">
            <span>
              <i className="icon-Star" />
            </span>
            <h2>
              <FormattedMessage {...messages.generalStringSavedPrograms} />
            </h2>
          </div>
        </Default>
      );
    } else if (!isSHS) {
      programsTop = <Loader />;
      if (!sharedSchedules.loading && sharedSchedules.loaded) {
        const compositeCards = sharedSchedules.result.map(sharedSchedule => (
          <CompositeProgramCard
            schedule={sharedSchedule}
            initScheduling={program => this.initScheduling(program, true)}
            isSHS={isSHS}
            isGT={isGT}
            isMS={isMS}
            removeNoMatchingTimeSlot={this.removeNoMatchingTimeSlot}
          />
        ));
        programsTop = (
          <div className={style.schedulePrograms} style={{ order: '0' }}>
            {compositeCards}
          </div>
        );
      }
    }

    return (
      <div className={style.scheduleProgramsContainer}>
        <div>{showProgramDetailTop && this.isProgramDetail() && this.renderSchoolDetail()}</div>
        {programsTop}
        {(isSHS || isGT || isMS) && (
          <div
            className={classNames(style.scheduleTitleContainer, {
              [style.scheduleTitleContainerMarginTop30]: !mobile,
              [style.scheduleTitleContainerMarginTop15]: mobile,
            })}
          >
            <ScheduleSubtitle user={user} isSHS={false} fullWidth />
          </div>
        )}

        <div className={style.schedulePrograms} data-coachmark="schedule-step-2">
          <Default>
            {this.isProgramDetail() && !showProgramDetailTop ? this.renderSchoolDetail() : this.renderProgramList()}
          </Default>
          <Mobile>{this.renderProgramList()}</Mobile>
        </div>
      </div>
    );
  };

  renderAppointments = () => {
    const { appointments, expressedInterests, noMatchingTimeSlots, programs, intl, user } = this.props;
    const { directoryProgramId, isSHS, isGT, isMS } = this.state;

    let schedulingCompletedLabel = messages.buttonSchedulingComplete;
    if (user.scheduleCompleted) {
      schedulingCompletedLabel = messages.buttonSchedulingAlreadyCompleted;
    }

    return (
      <div className={style.scheduleAppointmentsContainer}>
        <Default>
          {/* <div
            className={classNames(style.schedule__title, style['schedule__appointments-title'])}
            data-coachmark="schedule-step-3"
          > */}
          <h2
            className={classNames(style.scheduleTitle, style.scheduleAppointmentsTitle)}
            data-coachmark="schedule-step-3"
          >
            <span>
              <i className="icon-Calendar-Outline" />
            </span>
            <span>
              <FormattedMessage {...messages.generalStringScheduled} />
            </span>
          </h2>
        </Default>
        <div className={style.scheduleAppointments}>
          <AppointmentList
            appointments={appointments}
            expressedInterests={expressedInterests}
            noMatchingTimeSlots={noMatchingTimeSlots}
            selectedDirectoryProgramId={directoryProgramId}
            showSchoolDetail={this.showSchoolDetail}
            isSHS={isSHS}
            isGT={isGT}
            isMS={isMS}
            programs={programs}
            programClickAppointment={this.programClickAppointment}
          />
        </div>
      </div>
    );
  };

  renderProgramList = () => (
    <ProgramList
      programs={this.props.programs}
      schools={this.props.schools}
      initScheduling={this.initScheduling}
      removeNoMatchingTimeSlot={this.removeNoMatchingTimeSlot}
      showSchoolDetail={this.showSchoolDetail}
      programClick={this.programClick}
      user={this.props.user}
    />
  );

  renderSchoolDetail = () => {
    const { directorySchoolId, directoryProgramId } = this.state;
    const { schools, programs, user } = this.props;

    return (
      <ScheduleDetail
        school={{ ...schools.normalSchools.entities.school[directorySchoolId] }}
        directoryProgramId={directoryProgramId}
        programs={programs}
        programClick={this.programClick}
        showSchoolDetail={this.showSchoolDetail}
        initScheduling={this.initScheduling}
        removeNoMatchingTimeSlot={this.removeNoMatchingTimeSlot}
        showProgramList={this.showProgramList}
        programsLoading={programs.loading}
        user={user}
        detailShowsSchool={this.state.detailShowsSchool}
      />
    );
  };

  renderMobileButtons = () => {
    const { mobileRender } = this.state;
    const programClasses = ['button--no-style', style.scheduleProgramsButton];
    const appointmentClasses = ['button--no-style', style.scheduleAppointmentsButton];

    if (mobileRender === PROGRAMS) {
      programClasses.push(style.scheduleMainButtonActive);
    } else if (mobileRender === APPOINTMENTS) {
      appointmentClasses.push(style.scheduleMainButtonActive);
    }

    return (
      <Mobile>
        <div className={style.scheduleMainButtons} data-coachmark="schedule-mobile-step-3">
          <button className={classNames(...programClasses)} onClick={this.mobileShowPrograms}>
            <i className="icon-Star" /> <FormattedMessage {...messages.generalStringSavedPrograms} />
          </button>
          <button className={classNames(...appointmentClasses)} onClick={this.mobileShowAppointments}>
            <i className="icon-List" /> <FormattedMessage {...messages.generalStringScheduleList} />
          </button>
        </div>
      </Mobile>
    );
  };

  /* isLoading = () => {
    if( this.props.user.loading || this.props.studentAppointments.loading || this.props.sharedSchedules.loading || this.props.programs.loading || this.props.noMatchingTimeSlots.loading)
  } */

  render() {
    const { programs, sharedSchedules, user, schools, intl } = this.props;
    const { mobileRender, isSHS, showProgramDetailTop } = this.state;

    let renderedContent = <Loader text={customisedIntlFormatMessage(intl, messages.generalStringLoading)} />;
    if (schools.error || programs.error || sharedSchedules.error) {
      renderedContent = (
        <div className={style.scheduleRefresh}>
          The schedule data could not be loaded. Please&nbsp;
          <a href={encodeURI(window.location)}>refresh</a>&nbsp;the page to try again.
        </div>
      );
    } else if (schools.loaded && programs.loaded) {
      // if programs were initially loaded and there were no results, show the empty content
      renderedContent = !this.schedulableProgramsExist() ? (
        <Loader text={customisedIntlFormatMessage(intl, messages.generalStringLoading)} />
      ) : (
        <div className={style.scheduleWrapper}>
          <div>
            <div className={style.scheduleContainer}>
              <div className={style.scheduleTitleContainer} data-coachmark="schedule-step-1">
                <ScheduleTitle user={user} />
                {!showProgramDetailTop && (
                  <ScheduleSubtitle user={user} isSHS={isSHS} programs={programs} sharedSchedules={sharedSchedules} />
                )}
              </div>
              {this.renderMobileButtons()}
              <div className={style.scheduleMain}>
                <Mobile>
                  {this.isProgramDetail() ? this.renderSchoolDetail() : this.mobileRenderMapping[mobileRender]()}
                </Mobile>
                <Default>
                  {this.renderPrograms()}
                  {this.renderAppointments()}
                </Default>
              </div>
            </div>
          </div>
          {this.renderModal()}
          {this.coachmarks && this.coachmarksMobile && (
            <div>
              <Default>
                <Coachmarks steps={this.coachmarks} context="scheduled" />
              </Default>
              <Mobile>
                <Coachmarks steps={this.coachmarksMobile} context="scheduled" />
              </Mobile>
            </div>
          )}
        </div>
      );
    }

    return (
      <main className={style.root} role="presentation">
        {renderedContent}
      </main>
    );
  }
}

Schedule.defaultProps = {
  mobile: false,
};

Schedule.propTypes = {
  mobile: PropTypes.bool,
  // sk: user should be fleshed out
  user: PropTypes.shape({
    isSHS: PropTypes.bool.isRequired,
    isGT: PropTypes.bool.isRequired,
    applicationId: PropTypes.string.isRequired,
    scheduleCompleted: PropTypes.bool.isRequired,
    details: PropTypes.shape().isRequired,
    admissionProcess: PropTypes.string.isRequired,
  }).isRequired,
  schools: PropTypes.shape().isRequired,
  programs: PropTypes.shape().isRequired,
  sharedSchedules: PropTypes.shape().isRequired,
  appointments: PropTypes.shape().isRequired,
  studentAppointments: PropTypes.shape().isRequired,
  expressedInterests: PropTypes.shape().isRequired,
  noMatchingTimeSlots: PropTypes.shape().isRequired,
  appointmentForm: PropTypes.shape().isRequired,
  cancelAppointmentForm: PropTypes.shape().isRequired,
  updateAppointmentForm: PropTypes.shape().isRequired,
  expressInterestForm: PropTypes.shape().isRequired,
  expressedInterestsInstruments: PropTypes.shape().isRequired,
  unexpressInterestForm: PropTypes.shape().isRequired,
  noMatchingTimeSlotForm: PropTypes.shape().isRequired,
  studentInfo: PropTypes.func.isRequired,
  fetchSchedule: PropTypes.func.isRequired,
  fetchSharedSchedule: PropTypes.func.isRequired,
  fetchExpressedInterests: PropTypes.func.isRequired,
  fetchAppointments: PropTypes.func.isRequired,
  fetchStudentAppointments: PropTypes.func.isRequired,
  fetchNoMatchingTimeSlots: PropTypes.func.isRequired,
  getSchoolsPrograms: PropTypes.func.isRequired,
  getStudentApplications: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  setCustomFilters: PropTypes.func.isRequired,
  intl: PropTypes.shape().isRequired,
  schedulingCompleted: PropTypes.func.isRequired,
  scheduleCompletedForm: PropTypes.shape().isRequired,
  removeNoMatchingTimeSlot: PropTypes.func.isRequired,
  removeNoMatchingTimeSlotForm: PropTypes.shape().isRequired,
  showPopupContent: PropTypes.func.isRequired,
  fetchSharedScheduleGTFilteredLocations: PropTypes.func.isRequired,
  fetchSharedScheduleGTFiltered: PropTypes.func.isRequired,
  fetchExpressedInterestsInstruments: PropTypes.func.isRequired,
};

const mapState = ({
  user,
  schools,
  schedulePrograms,
  sharedSchedules,
  appointments,
  studentAppointments,
  expressedInterests,
  noMatchingTimeSlots,
  appointmentForm,
  cancelAppointmentForm,
  updateAppointmentForm,
  expressInterestForm,
  unexpressInterestForm,
  scheduleCompletedForm,
  noMatchingTimeSlotForm,
  removeNoMatchingTimeSlotForm,
}) => ({
  user,
  schools,
  programs: schedulePrograms,
  sharedSchedules,
  appointments,
  studentAppointments,
  expressedInterests,
  noMatchingTimeSlots,
  appointmentForm,
  cancelAppointmentForm,
  updateAppointmentForm,
  expressInterestForm,
  unexpressInterestForm,
  scheduleCompletedForm,
  noMatchingTimeSlotForm,
  removeNoMatchingTimeSlotForm,
});

const mapDispatch = {
  studentInfo,
  fetchSchedule,
  fetchSharedSchedule,
  fetchAppointments,
  fetchStudentAppointments,
  fetchExpressedInterests,
  fetchNoMatchingTimeSlots,
  resetForm,
  setCustomFilters,
  getSchoolsPrograms,
  getStudentApplications,
  schedulingCompleted,
  removeNoMatchingTimeSlot,
  showPopupContent,
  fetchSharedScheduleGTFiltered,
  fetchSharedScheduleGTFilteredLocations,
  fetchExpressedInterestsInstruments,
};

// export default withRtl(style)(injectIntl(connect(mapState, mapDispatch)(withStyles(style)(Schedule))));
export default compose(
  //
  injectIntl,
  withRtl(style),
  withStyles(style),
  connect(
    mapState,
    mapDispatch,
  ),
)(Schedule);
